import React from "react";
import Box from "@mui/material/Box";

import AppList from "../../../components/apps/AppList";
import SenderMessageItem from "./SenderMessageItem";
import { Message } from "../../../types/models/Chat";
import ReceiverMessageItem from "./ReceiverMessageItem";

interface MessagesListProps {
  messages: Message[];
}

const MessageList: React.FC<MessagesListProps> = ({ messages }) => {
  return (
    <Box sx={{ px: 1, py: 6 }}>
      <AppList
        animation="transition.slideUpIn"
        data={messages}
        renderRow={(item: Message, index: number) => {
          const myMsg = item.isAdmin ? false : true;
          if (myMsg) {
            return (
              <SenderMessageItem
                item={item}
                key={item.id}
                isPreviousSender={
                  index > 0 && item.member.id === messages[index - 1].member.id
                }
                isLast={
                  (index + 1 < messages.length &&
                    item.member.id !== messages[index + 1].member.id) ||
                  index + 1 === messages.length
                }
              />
            );
          } else {
            return <ReceiverMessageItem item={item} key={item.id} />;
          }
        }}
      />
    </Box>
  );
};

export default MessageList;
